import axios from 'axios';

import { getDecodedStartappQuery } from '../../helpers/get-decoded-startapp-query';
import { getBaseUrl } from '../helpers';

export const getTokenNoAuth = async (): Promise<string> => {
  const decoded = getDecodedStartappQuery();

  if (!decoded.otp) return '';

  const url = `${getBaseUrl()}/v1/noauth2?otp=${decoded.otp ?? null}`;

  const res = await axios.post(url);
  return res.data?.token;
};
